"use client"

import "../assets/css/whatsapp-button.css"

export default function WhatsAppButton() {
  const whatsappNumber = "94771172694"
  const whatsappMessage = "Hello! I'm interested in your products and services."

  const handleWhatsAppClick = () => {
    const encodedMessage = encodeURIComponent(whatsappMessage)
    const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`
    window.open(whatsappLink, "_blank")
  }

  return (
    <button
      className="whatsapp-button"
      onClick={handleWhatsAppClick}
      aria-label="Contact us on WhatsApp"
      title="Contact us on WhatsApp"
    >
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
        alt="WhatsApp"
        className="whatsapp-icon"
      />
    </button>
  )
}
